module.exports = __webpack_public_path__ + "static/musicfreedom_0-aee06cdb5b1a406d163d237e160722ed.jpg";